import { Checkbox, FormControl, FormControlLabel, FormHelperText } from "@material-ui/core";

export const AgreeTermCheck = ({ agree, setAgree, error }) => {
  return (
    <FormControl error={error}>
      <FormControlLabel
        id="term-checkbox"
        control={
          <Checkbox
            color="primary"
            checked={agree}
            onChange={(event) => setAgree(event.target.checked)}
          />
        }
        label="I agree to the terms & conditions"
      />
      {error && <FormHelperText>Please agree the terms of service</FormHelperText>}
    </FormControl>
  );
};
